module.exports = __webpack_public_path__ + "static/media/placeholder.fe38aaa3.jpg";